export const CATEGORY_KIND_PAST_EXAM = 'past_exam'
export const CATEGORY_KIND_MOCK_EXAM = 'mock_exam'
export const CATEGORY_KIND_TRAINING = 'training'

export function isExamCategory(cat) {
  if (!cat) return false
  const kind = cat.kind || ''
  if (kind === CATEGORY_KIND_PAST_EXAM || kind === CATEGORY_KIND_MOCK_EXAM) {
    return true
  }
  const name = String(cat.name || '')
  return name === '历年真题' || name === '模拟考试'
}

export function examCardMeta(cat) {
  const kind = cat.kind || (cat.name === '模拟考试' ? CATEGORY_KIND_MOCK_EXAM : CATEGORY_KIND_PAST_EXAM)
  if (kind === CATEGORY_KIND_MOCK_EXAM || cat.name === '模拟考试') {
    return {
      subtitle: '还原真实考试场景',
      icon: 'edit',
      theme: 'mock'
    }
  }
  return {
    subtitle: '近十年考试真题',
    icon: 'notes-o',
    theme: 'past'
  }
}
